import styled from 'styled-components';
import {Typography} from '@/components/Typography';
import {SubwayData} from '@/map/@types';
import {AROUND_DATA_OPTIONS, SUBWAY_LINE_COLORS} from '@/map/constants';
import {AreaAnalyticsFilter} from '@/map/enums';
import {Flexbox} from '@/styled-components';
import {palette} from '@/styles';
import {withCommaWithUnit} from '@/utils';
import {SpotRoundMark} from '../../Marker';
import {SwiperSlideCardWrapper} from '../Swiper/StyledComponents';

interface IProps {
  type: AreaAnalyticsFilter;
  item: any;
}

export const NearbyInfoCard = ({type, item}: IProps) => {
  const options = AROUND_DATA_OPTIONS[type];

  return (
    <SwiperSlideCardWrapper>
      <Root>
        <Title>
          <IconWrapper>
            <SpotRoundMark
              color={
                type === AreaAnalyticsFilter.SUBWAY
                  ? SUBWAY_LINE_COLORS[item?.subways?.[0]?.line] ??
                    options.mobile?.color
                  : options.mobile?.color
              }
              icon={options.mobile?.icon}
              typeLabel={options.label}
            />
          </IconWrapper>
          <Typography variant="medium16" fontWeight="500">
            {(
              {
                [AreaAnalyticsFilter.BUS]: item.stopName,
              } as any
            )[type] ?? item.name}
          </Typography>
        </Title>
        <Typography variant="medium14" color={palette.gray600} as="div">
          {(
            {
              [AreaAnalyticsFilter.DAYCARE_CENTER]: `원아 수 ${withCommaWithUnit(
                item.childrenCount,
                {unit: '명', placeholder: '정보 없음'}
              )}`,
              [AreaAnalyticsFilter.KINDERGARTEN]: `원아 수 ${withCommaWithUnit(
                item.studentsCount,
                {unit: '명', placeholder: '정보 없음'}
              )}`,
              [AreaAnalyticsFilter.BUS]: `일 평균 승하차 ${withCommaWithUnit(
                item.avgNumberOfRidesPerDay,
                {unit: '명', placeholder: '정보 없음'}
              )}`,
              [AreaAnalyticsFilter.SUBWAY]: `일 평균 승하차 ${withCommaWithUnit(
                (item as SubwayData).subways?.[0]?.getOnOffAvg,
                {unit: '명', placeholder: '정보 없음'}
              )}`,
              [AreaAnalyticsFilter.HOSPITAL]: `${withCommaWithUnit(
                item.bedsCount,
                {unit: ' 병상', placeholder: '정보 없음'}
              )}`,
            } as any
          )[type] ??
            `학생 수 ${withCommaWithUnit(item.studentsCount, {
              unit: '명',
              placeholder: '정보 없음',
            })}`}
        </Typography>
      </Root>
    </SwiperSlideCardWrapper>
  );
};

const Root = styled.div`
  padding: 20px 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Title = styled(Flexbox)`
  gap: 8px;
`;

const IconWrapper = styled.div`
  width: 22px;
  height: 22px;
  flex-shrink: 0;
`;
